import { Checkbox, Collapse, Radio } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const DyForm: React.FC<{
    rxConfig: TemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
}> = ({ rxConfig, saveRxConfigInState }) => {
    return (
        <Collapse
            expandIcon={() => (
                <div className="rounded-4 w-26 h-26 bg-darwin-neutral-600 flex items-center justify-center">
                    <div className="w-full h-full flex items-center justify-center">
                        <svg
                            className="fill-white"
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="13"
                            viewBox="0 0 13 13"
                        >
                            <path d="M12.0752 1.83594L11.1846 0.945312C10.9033 0.664062 10.5049 0.5 10.1299 0.5C9.75488 0.5 9.35645 0.664062 9.0752 0.945312L1.24707 8.77344C1.17676 8.82031 1.15332 8.89062 1.12988 8.96094L0.520508 12.0312C0.473633 12.2891 0.661133 12.5 0.87207 12.5C0.895508 12.5 0.942383 12.5 0.96582 12.5L4.03613 11.8906C4.10645 11.8672 4.17676 11.8438 4.24707 11.7734L12.0752 3.94531C12.6611 3.35938 12.6611 2.42188 12.0752 1.83594ZM3.59082 10.8359L1.83301 11.1875L2.18457 9.42969L2.77051 8.84375V10.25H4.17676L3.59082 10.8359ZM3.89551 9.125V7.71875L8.02051 3.59375L9.4502 5L5.30176 9.125H3.89551Z"></path>
                        </svg>
                    </div>
                </div>
            )}
        >
            <Panel header={<div className="font-700">Custom Section</div>} key="1">
                <p className="mr-16 space-y-4">
                    <div className="cursor-pointer">
                        <p
                            className="cursor-pointer flex flex-1 items-center justify-between"
                            onClick={() => {
                                saveRxConfigInState({
                                    dyform_in_unbold: !rxConfig?.dyform_in_unbold,
                                });
                            }}
                        >
                            <span>Make the custom section name bold</span>
                            <Checkbox checked={!rxConfig?.dyform_in_unbold}></Checkbox>
                        </p>
                    </div>
                    <div className="cursor-pointer">
                        <div className="flex-1 items-center justify-center">
                            <span>Layout</span>
                            <Radio.Group
                                value={rxConfig?.dyform_data_layout || 'bullet'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dyform_data_layout: e.target.value,
                                    });
                                }}
                                className="flex items-center space-x-4 items-center justify-center"
                            >
                                <AntTooltip content="Prefer for short data">
                                    <Radio className="flex" value="bullet">
                                        Default
                                    </Radio>
                                </AntTooltip>
                                <AntTooltip content="Prefer for long data">
                                    <Radio value="inline">Inline</Radio>
                                </AntTooltip>
                            </Radio.Group>
                        </div>
                    </div>
                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                    <div className="flex items-center justify-between">
                        <div>Heading</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dyform_heading_color || '#2188FF'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dyform_heading_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dyform_heading_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Key Elements</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dyform_name_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dyform_name_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dyform_name_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div>Properties</div>{' '}
                        <div className="flex space-x-12">
                            <input
                                type="color"
                                id="head"
                                name="head"
                                value={rxConfig?.dyform_properties_color || '#000000'}
                                onChange={(e) => {
                                    saveRxConfigInState({
                                        dyform_properties_color: e.target.value,
                                    });
                                }}
                                className="circular-color-input"
                            />

                            <AntTooltip content="Reset">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="w-18 h-18 fill-neutral-1 cursor-pointer"
                                    onClick={() => {
                                        saveRxConfigInState({
                                            dyform_properties_color: '',
                                        });
                                    }}
                                >
                                    <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"></path>
                                </svg>
                            </AntTooltip>
                        </div>
                    </div>
                </p>
            </Panel>
        </Collapse>
    );
};

export default DyForm;
